// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-item-container {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  border-bottom: 1px solid #c1c1c1;
  padding: 0 10px;
}
.notification-item-container .full-name {
  grid-column: 1;
  grid-row: 1;
  font-size: 0.8em;
  font-weight: bold;
  margin: 0;
  margin-top: 10px;
}
.notification-item-container .uid {
  grid-column: 1;
  grid-row: 2;
  font-size: 0.85em;
  margin: 2px 0;
}
.notification-item-container .status {
  grid-column: 1/3;
  grid-row: 3;
  font-size: 0.85em;
  margin: 0;
  margin-bottom: 10px;
}
.notification-item-container .created {
  grid-column: 2;
  grid-row: 1;
  font-size: 0.8em;
  font-weight: bold;
  color: grey;
  margin: 0;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/view/control/status-change-notification/status-change-notification.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,+BAAA;EACA,wBAAA;EACA,gCAAA;EACA,eAAA;AACJ;AAAI;EACI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;AAER;AAAI;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;AAER;AAAI;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AAER;AAAI;EACI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AAER","sourcesContent":[".notification-item-container {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    grid-template-rows: auto;\n    border-bottom: 1px solid #c1c1c1;\n    padding: 0 10px;\n    .full-name {\n        grid-column: 1;\n        grid-row: 1;\n        font-size: 0.8em;\n        font-weight: bold;\n        margin: 0;\n        margin-top: 10px;\n    }\n    .uid {\n        grid-column: 1;\n        grid-row: 2;\n        font-size: 0.85em;\n        margin: 2px 0;\n    }\n    .status {\n        grid-column: 1 / 3;\n        grid-row: 3;\n        font-size: 0.85em;\n        margin: 0;\n        margin-bottom: 10px;\n    }\n    .created {\n        grid-column: 2;\n        grid-row: 1;\n        font-size: 0.8em;\n        font-weight: bold;\n        color: grey;\n        margin: 0;\n        margin-top: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
